import productData from 'services/productData';

const DEFAULT_METADATA = {
    title: 'OPSWAT Accounts | Login',
    description: 'Don\'t have an OPSWAT Account? Create new.'
};

function usePageMetadata(appName) {
    if (!appName) {
        appName = 'MyOPSWAT';
    }
    const productInfo = productData[appName];

    return {
        pageTitle: productInfo.title || DEFAULT_METADATA.title,
        pageDescription: productInfo.description || DEFAULT_METADATA.description
    };
}

export default usePageMetadata;
